/** Theme-aligned palette (app blues / accents) — same family for all fallbacks */
const AVATAR_COLORS = [
  "#006aa2",
  "#0a4d6e",
  "#1a7ab8",
  "#2d8bc9",
  "#0d6efd",
  "#146c94",
  "#1e6091",
  "#168aad",
  "#0077b6",
  "#023e8a",
];

const normalize = (name) =>
  String(name ?? "")
    .trim()
    .toLowerCase();

function hashString(str) {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = str.charCodeAt(i) + ((h << 5) - h);
  }
  return Math.abs(h);
}

/**
 * First word + second word initial (e.g. "Los Angeles Lakers" → "LL").
 * Single-word teams use first two letters (e.g. "Lakers" → "LA").
 */
export function getTeamInitials(teamName) {
  const parts = String(teamName ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length >= 2) {
    return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
  }
  if (parts.length === 1 && parts[0].length >= 2) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  if (parts.length === 1) {
    return (parts[0][0] || "?").toUpperCase();
  }
  return "?";
}

export function getTeamAvatarColor(teamName) {
  const key = normalize(teamName);
  if (!key) return AVATAR_COLORS[0];
  return AVATAR_COLORS[hashString(key) % AVATAR_COLORS.length];
}
